(() => {
  const scopes = {books: ' AND tag:ebay-sync AND -tag:store-ygoods', goods: ' AND tag:store-ygoods'};
  const bind = (root = document) => root.querySelectorAll('form[data-jb-scope]').forEach(form => {
    if (form.dataset.jbBound) return;
    form.dataset.jbBound = 'true';
    form.addEventListener('formdata', event => {
      const suffix = scopes[form.dataset.jbScope];
      const query = String(event.formData.get('q') || '').trim();
      if (suffix && query) {
        const fields = ['title', 'body', 'product_type', 'vendor', 'variants.title', 'variants.sku'];
        const phrase = query.replace(/["\\()]/g, '').replace(/\s+/g, ' ').trim();
        if (phrase) event.formData.set('q', `(${fields.map(field => `${field}:"${phrase}"`).join(' OR ')})` + suffix);
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
